// extracted by mini-css-extract-plugin
export default {"modal_overlay":"styles_modal_overlay__ythCz","modal":"styles_modal__AuhjQ"};